module.exports = __webpack_public_path__ + "7e30178f89d4d8cd263471964b22dc10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/cooperation/success-icon.jpg
// module id = 988
// module chunks = 3